import type { PropsWithChildren } from 'react';
import Head from 'next/head';
import { Flex, Link, Text, Fade, Box } from '@chakra-ui/react';
import { MainContainer } from '@/components/GlobalComponents';
import { colors } from '@/styles/theme/foundations/colors';
import { STATUS_PAGE_URL } from '@/modules/link';
import { useRouter } from 'next/router';

export default function LoginLayout({ children }: PropsWithChildren) {
  const router = useRouter();
  const fadeKey = router.asPath;

  return (
    <MainContainer
      className="main-container"
      direction="column"
      minHeight="100vh"
      variant="main"
      backgroundColor={colors.background.page.dark}
    >
      <Head>
        <title>Nabis - Sign in</title>
        <meta name="description" content="Nabis - Sign in" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <Flex
        flexDirection={'column'}
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        width="100%"
        px={'1rem'}
      >
        <Fade in={true} key={fadeKey} style={{ width: '100%' }}>
          <Box maxW={{ base: '100%', md: '438px' }} mx="auto">
            {children}
          </Box>
        </Fade>
      </Flex>

      <Flex position={'fixed'} bottom={6} width={'100%'} justifyContent={'center'}>
        <Text variant="secondary" fontSize={12} padding={'0 12px'}>
          © {new Date().getFullYear()} Nabis
        </Text>
        <Link
          href={STATUS_PAGE_URL}
          borderLeft={`1px solid ${colors.border.opaque.light}`}
          borderRight={`1px solid ${colors.border.opaque.light}`}
        >
          <Text variant="secondary" fontSize={12} padding={'0 12px'}>
            System Status
          </Text>
        </Link>
        <Text
          variant="secondary"
          fontSize={12}
          padding={'0 12px'}
          as={Link}
          href="https://www.nabis.com/legal/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Text>
      </Flex>
    </MainContainer>
  );
}
